<template>
  <div>
    <transition name="animeTitle">
      <a
        v-show="contactShow"
        class="mail-wrap"
        href="http://inouecd.jp/form/contact.php"
      >
        <div class="inner-wrap py-6">
          <img
            class="py-2 w-14 lg:py-2 lg:w-12 footer-log"
            alt="井上自動車販売 中古自動車 豊田市 愛知県"
            src="../assets/img/top/mail-logo.gif"
          />
          <span class="mail-text">お問い合わせはこちらから</span>
        </div></a
      >
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contactShow: false,
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll: function () {
      const top = this.$el.getBoundingClientRect().top;
      if (!this.contactShow) {
        this.contactShow = top < window.innerHeight + 1;
      }
    },
  },
};
</script>

<style scoped lang="scss">
div {
  margin: 30px 0 64px 0;
  .mail-wrap {
    .inner-wrap {
      margin: auto;
      width: 300px;
      // margin: 0 66px;
      padding: 0;
      border-top: solid 0.13em rgb(226, 209, 209);
      border-bottom: solid 0.13em rgb(226, 209, 209);
      display: flex;
      .footer-log {
        height: 70px;
        object-fit: cover;
      }
      .mail-text {
        color: #a1a0a0;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        padding-left: 15px;
      }
    }
  }
  a {
    cursor: pointer;
  }
  a:hover {
    opacity: 0.5;
    color: #141414;
    transition: 0.4s ease;
  }
}

.animeTitle-enter-active {
  transition: opacity 2s, transform 2s;
}
.animeTitle-enter {
  opacity: 0;
  transform: translateX(-40px);
}

@media (max-width: 360px) {
  .footer {
    .flex {
      h1 {
        top: 60px;
        .text {
          span {
            font-size: 14px;
          }
        }
      }
      .logo {
        top: 190px;
      }
      h2 {
        top: 250px;
        .text {
          span {
            font-size: 13px;
          }
        }
      }
      .mail-wrap {
        top: 120px;
        .inner-wrap {
          width: 250px;
          // margin: 0 66px;
          padding: 0;
          border-top: solid 0.13em rgb(255, 255, 255);
          border-bottom: solid 0.13em rgb(255, 255, 255);
          display: flex;
          .footer-log {
            width: 50px;
            height: 68px;
            object-fit: cover;
          }
          .mail-text {
            padding-left: 15px;
          }
        }
      }
      small {
        position: absolute;
        top: 530px;
        span {
          color: #ffffff;
          font-weight: 600;
        }
      }
    }
    a {
      display: block;
      position: relative;
      top: 100px;
      cursor: pointer;
    }
    a:hover {
      opacity: 0.5;
      color: #141414;
      transition: 0.4s ease;
    }

    .content {
      position: relative;
      height: 20vh;
      text-align: center;
      background-color: white;
    }
  }
  .footer::before {
    background-color: rgba(0, 0, 0, 0.1);
    /* どの範囲に重ねるかを指定 */
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    content: "";
  }
  .animeTitle-enter-active {
    transition: opacity 2s, transform 2s;
  }
  .animeTitle-enter {
    opacity: 0;
    transform: translateX(-40px);
  }
}

@media (min-width: 1024px) {
  .footer {
    background-image: url(../assets/img/top/footer-photo-pc.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center 85%;
    margin-bottom: 0px;
    .inner-footer {
      height: 70vh;
      width: 100%;
    }
    .flex {
      h1 {
        font-weight: 600;
        letter-spacing: 1px;
        // text-align: start;
        position: absolute;
        top: 66px;
        .text {
          color: #ffffff;
          padding: 0 6px;
          font-size: 22px;
          span {
            font-size: 15px;
          }
        }
      }
      .logo {
        width: 12%;
        height: 50px;
        top: 210px;
      }
      h2 {
        // font-family: "Lato", sans-serif;
        font-weight: 500;
        letter-spacing: 1px;
        line-height: 1.4em;
        position: absolute;
        top: 270px;
        .text {
          color: #ffffff;
          padding: 0 6px;
          font-size: 18px;
          span {
            font-size: 14px;
            font-weight: 600;
          }
        }
      }
      .mail-wrap {
        .inner-wrap {
          .footer-log {
            height: auto;
          }
          .mail-text {
            font-size: 16px;
            padding-left: 30px;
          }
        }
      }
      small {
        top: 510px;
      }
    }
    a {
      display: block;
      position: relative;
      top: 150px;
      cursor: pointer;
    }
  }
}
</style>
